import type { Card as CardClass } from '@/core/Card';

/**
 * チーム
 */
export enum Team {
  TEAM_1 = 1, // プレイヤー1 + プレイヤー2
  TEAM_2 = 2  // プレイヤー3
}

/**
 * プレイヤーインターフェース
 */
export interface Player {
  /** プレイヤーID */
  id: string;
  /** プレイヤー名 */
  name: string;
  /** 所属チーム */
  team: Team;
  /** 手札 */
  hand: CardClass[];
  /** AIプレイヤーかどうか */
  isAI: boolean;
  /** 接続状態（オンラインプレイ用） */
  isConnected: boolean;
}
